import React from 'react';
import moment from 'moment';

import { getDaysOnMarketAt } from 'common/listingHelpers';
import { formatPrice } from 'common/formatters';
import { CONCESSION_SCHEDULE_TYPES_TO_LABELS } from 'common/concessionConstants';

import {
  DATA_TABLE_SOURCE_LISTING_CONCESSIONS_HISTORY,
  DATA_TABLE_VIEW_ID_LISTING_CONCESSIONS_HISTORY,
} from 'common/dataTableConstants';

import { SR_TABLE_THEME_HISTORICAL } from 'client/components/SrTable';
import SrDataTableUI from 'client/components/SrDataTableUI';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrText from 'client/components/SrText';

function getDataTableSettingsFromProps({ listingId }) {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_LISTING_CONCESSIONS_HISTORY,
    rootViewId: DATA_TABLE_VIEW_ID_LISTING_CONCESSIONS_HISTORY,
    viewId: `${DATA_TABLE_VIEW_ID_LISTING_CONCESSIONS_HISTORY}_${listingId}`,
    initialViewSettings: {
      filter: {
        listingId,
      },
      loadAllData: true,
    },
    itemsPropName: 'concessions',
  };
  return dataTableSettings;
}

const SrConcessionsHistoryDataTable = ({ listingId }) => {
  const formatDate = (date) => {
    return moment(date).format('MM/DD/YYYY');
  };

  const headers = [
    {
      content: 'Start Date',
      dataTableFieldId: 'startDate',
      width: '20%',
    },
    {
      content: 'DOM',
      dataTableFieldId: 'daysOnMarketOnCreation',
      width: '20%',
    },
    {
      content: 'Amount',
      dataTableFieldId: 'amount',
      width: '20%',
    },
    {
      content: 'Type',
      dataTableFieldId: 'type',
      width: '20%',
    },
    {
      content: 'End Date',
      dataTableFieldId: 'endDate',
      width: '20%',
    },
  ];

  return (
    <div>
      <SrDataTableConnected {...getDataTableSettingsFromProps({ listingId })}>
        {({
          concessions,
          viewSettings,
          dataTableApiState,
          onInfiniteScrollWrapperRef,
          dataTableIsFullyLoaded,
        }) => {
          // eslint-disable-line max-len
          if (concessions.length === 0 && dataTableIsFullyLoaded) {
            return (
              <SrText font="greycliff" weight="500" fontSize="16px">
                There are no concessions for this listing.
              </SrText>
            );
          }
          return (
            <div ref={onInfiniteScrollWrapperRef}>
              <SrDataTableUI
                sticky
                theme={SR_TABLE_THEME_HISTORICAL}
                dataTableViewSettings={viewSettings}
                headers={headers}
                minWidth="100%"
                rows={concessions.map((concession) => {
                  return {
                    cells: [
                      {
                        content: formatDate(concession.startDate),
                      },
                      {
                        content: getDaysOnMarketAt({
                          listing: concession.listing,
                          date: concession.startDate,
                        }),
                      },
                      {
                        content: formatPrice(concession.amount),
                      },
                      {
                        content: CONCESSION_SCHEDULE_TYPES_TO_LABELS[concession.scheduleType],
                      },
                      {
                        content: formatDate(concession.endDate),
                      },
                    ],
                  };
                })}
              />
              {dataTableApiState.inProgress && (
                <div>
                  <div className="loading-gif clearfix" />
                </div>
              )}
            </div>
          );
        }}
      </SrDataTableConnected>
    </div>
  );
};

SrConcessionsHistoryDataTable.displayName = 'SrConcessionsHistoryDataTable';

export default SrConcessionsHistoryDataTable;
